/* created by CoolGuy on 2018/10/14 */
import React from 'react';
import { Select } from 'antd';
const Option = Select.Option;
class SearchSelect extends React.Component{
    state = {
        value:'',
    }
    handleChange = (value) => {
        console.log('change',value)
        this.setState({ value });
        this.props.onChange(value);
    }
    handleSearch = (value) => {
        console.log('search',value)
        this.props.onSearch && this.props.onSearch(value);
    }
    render(){
        let options = this.props.data.map(d => {
            if(d && d.key && d.name) {
                return <Option key={d.key}>{d.name}</Option>
            }
            return <Option key={d.value}>{d.text}</Option>;
        });
        return (
            <Select
                showSearch
                allowClear={true}
                value={this.state.value}
                placeholder={this.props.placeholder}
                style={this.props.selectStyle}
                defaultActiveFirstOption={false}
                filterOption={false}
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                onSelect={this.props.onSelect}
            >
                {options}
            </Select>)
    }
}

export default SearchSelect;



// WEBPACK FOOTER //
// ./src/components/Select/SearchSelect.js